var _rect, _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteConfirmationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 6,
    fill: "#FFEAEC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 17.25,
    stroke: "#FF162B",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.25 21.5C33.6562 21.5 34 21.8438 34 22.25C34 22.6875 33.6562 23 33.25 23H32.875L32.125 33.1562C32.0312 34.2188 31.1875 35 30.125 35H23.8438C22.7812 35 21.9375 34.2188 21.8438 33.1562L21.0938 23H20.75C20.3125 23 20 22.6875 20 22.25C20 21.8438 20.3125 21.5 20.75 21.5H22.9062L24.0625 19.7812C24.375 19.3125 24.9375 19 25.5312 19H28.4375C29.0312 19 29.5938 19.3125 29.9062 19.7812L31.0625 21.5H33.25ZM25.5312 20.5C25.4375 20.5 25.3438 20.5625 25.3125 20.625L24.7188 21.5H29.25L28.6562 20.625C28.625 20.5625 28.5312 20.5 28.4375 20.5H25.5312ZM31.375 23H22.5938L23.3438 33.0625C23.375 33.3125 23.5938 33.5 23.8438 33.5H30.125C30.375 33.5 30.5938 33.3125 30.625 33.0625L31.375 23Z",
    fill: "#FF162B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteConfirmationIcon);
export default __webpack_public_path__ + "static/media/deleteConfirmationIcon.d75384ec2eed433f40193c03f8a73036.svg";
export { ForwardRef as ReactComponent };